import { selectIsAuthenticated } from '@/domain/auth/auth.selectors';
import { CalculateFestivalEnv } from '@/domain/impact-calculate-festival/entities/calculate-festival-env.entity';
import { selectImpactCalculateFestivalEnvForProject } from '@/domain/impact-calculate-festival/impact-calculate-festival.selectors';
import { selectCurrentProjectFestival } from '@/domain/project-festival/project-festival.selectors';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import {
  displayDecimal,
  formatTopicScore,
} from '../../pdf/utils/display-scores.utils';
import ArrowIcon from '../assets/arrow.svg';
import CrossImg from '../assets/cross.svg';
import FairlyScorePillLogo from '../assets/fairly-score-pill-logo.svg';
import { MainScorePill } from '../components/MainScorePill';

export function ScoreCardsFestivalC3() {
  document.documentElement.classList.add('score-card');
  document.body.classList.add('score-card');

  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const festival = useAppSelector(selectCurrentProjectFestival);
  const festivalId = festival?.id ?? 0;

  const impactEnv = useAppSelector(
    selectImpactCalculateFestivalEnvForProject(festivalId),
  ) satisfies CalculateFestivalEnv;

  if (!isAuthenticated) {
    return <h1>{translate('PdfExports.user-not-authentified')}</h1>;
  }

  if (!festival) {
    return <h1>{translate('PdfExports.festival-not-found')}</h1>;
  }

  const impactEnvScore100 =
    !impactEnv.score || !impactEnv.maxScore
      ? 0
      : Math.round((impactEnv.score * 100) / impactEnv.maxScore);

  return (
    <div id="card3" className="score-card-section">
      <div className="title">
        <img
          src={FairlyScorePillLogo}
          width="80"
          height="80"
          alt="Fairly logo"
        />
        <img src={CrossImg} width="30" height="30" />
        <h1>{festival.name}</h1>
      </div>
      <div className="scores">
        <div className="subtitle">
          <div className="score-row-left">
            <img src={ArrowIcon} width="40" height="40" />
            <span>{translate('Projects.env')}</span>
          </div>
          <MainScorePill scoreLetter={impactEnv.scoreLetter} type="env" />
        </div>
        <div className="score-row score-highlight">
          <span>{translate('PdfExports.total-score')}</span>
          <span className="highlight">
            {displayDecimal(impactEnvScore100)}/{100}
          </span>
        </div>
        <div className="score-row">
          <span>{translate('Env.Topics.GLOBAL_CO2')}</span>
          <span>{formatTopicScore(impactEnv.topics.GLOBAL_CO2)}</span>
        </div>
        <div className="score-row">
          <span>{translate('Env.Topics.FOOD_BEVERAGES')}</span>
          <span>{formatTopicScore(impactEnv.topics.FOOD_BEVERAGES)}</span>
        </div>
        <div className="score-row">
          <span>{translate('Env.Topics.RESOURCES_POLLUTION')}</span>
          <span>{formatTopicScore(impactEnv.topics.RESOURCES_POLLUTION)}</span>
        </div>
        <div className="score-row">
          <span>{translate('Env.Topics.COMMUNICATION')}</span>
          <span>{formatTopicScore(impactEnv.topics.COMMUNICATION)}</span>
        </div>
        <div className="score-row">
          <span>{translate('Env.Topics.PUBLIC_ENGAGEMENT')}</span>
          <span>{formatTopicScore(impactEnv.topics.PUBLIC_ENGAGEMENT)}</span>
        </div>
      </div>
    </div>
  );
}
